// extracted by mini-css-extract-plugin
module.exports = {"root":"g_M","headline":"g_N","grid":"g_P","gridItem":"g_Q","browseMoreNav":"g_R f_t"};